__turbopack_context__.v({
  "body": "SeeTheWorld-module__dgXP1W__body",
  "bodyHtml": "SeeTheWorld-module__dgXP1W__bodyHtml",
  "bodyWrap": "SeeTheWorld-module__dgXP1W__bodyWrap",
  "clamped": "SeeTheWorld-module__dgXP1W__clamped",
  "clampedHtml": "SeeTheWorld-module__dgXP1W__clampedHtml",
  "section": "SeeTheWorld-module__dgXP1W__section",
  "titleHtml": "SeeTheWorld-module__dgXP1W__titleHtml",
  "toggle": "SeeTheWorld-module__dgXP1W__toggle",
  "toggleBlock": "SeeTheWorld-module__dgXP1W__toggleBlock",
});
